export default __webpack_public_path__ + "static/media/video.be576a8f.svg";